import axiosInstance, { handleLogout } from './axiosInstance';

export const getFinance = async(pamars) => {
    try {
        const response = await axiosInstance.get('finance/', { params: pamars });
        return response.data;
    } catch (error) {
        handleLogout(error);
        return null;
    }
}

export async function get_sexting(auth_token,c_id,build,groupId=null,teamId=null,emplId=null, timestamp_from, timestamp_to, activityTracking = false) {
    const params = new URLSearchParams();
    params.append('timestamp_from', timestamp_from);
    params.append('timestamp_to', timestamp_to);

    if (auth_token) {
        try {
            let url = `sexting/?&build=${build}&userToken=${auth_token}&${params.toString()}`
            if (c_id !== null) {url += `&companyID=${c_id}`;}
            if (teamId !== null) {url += `&teamId=${teamId}`;}
            if (groupId !== null) {url += `&groupId=${groupId}`;}
            if (emplId !== null) {url += `&emplId=${emplId}`;}
            if (activityTracking === true) {url += `&activity=true`;}
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            return false
        }
    }
}